<div *ngIf="isMyCallcard" class="engaged-people" (click)="onEngagedPeopleButtonClicked($event)">
  {{ engagedPeople | number: '2.0-0' }}
</div>
